import { computeIsBenchmarkUnfiltered } from "helpers/filter-scope"
import { LONG } from "resources/position-sets/composition"
import { useAppSelector } from "hooks/redux"
import BasisChip from "components/filter-scope-basis-chip"
import { useDashboardId } from "../context/dashboard-id"
import { selectCoreState } from "../store/selectors/select-core-state"
import { useFilteredSegment } from "../helpers"
import { useEffectiveFilterScope } from "../hooks/use-effective-filter-scope"

interface InstrumentCompositionMetadata {
  compositionType?: string
}

interface FilterScopeBasisChipProps {
  instrumentMetadata?: InstrumentCompositionMetadata | null
  comparisonInstrumentMetadata?: InstrumentCompositionMetadata | null
}

export default function FilterScopeBasisChip({ instrumentMetadata, comparisonInstrumentMetadata }: FilterScopeBasisChipProps) {
  const dashboardId = useDashboardId()
  const { filter, normalization, comparisonInstrument } = useAppSelector((state) => selectCoreState(state, dashboardId))
  const appliedSegment = useFilteredSegment(filter, normalization)
  const effectiveFilterScope = useEffectiveFilterScope()

  if (!computeIsBenchmarkUnfiltered(effectiveFilterScope, appliedSegment)) {
    return null
  }

  const isLongOnly = instrumentMetadata?.compositionType === LONG && (!comparisonInstrument || comparisonInstrumentMetadata?.compositionType === LONG)

  return <BasisChip showGrossExposureNote={!isLongOnly} />
}
